<template>
  <div id="not-available-page" v-if="surveyDetails && surveyDesign">
    <b-container>
      <b-row>
        <b-col lg="10" class="mx-auto text-center">
          <b-img
            :src="
              surveyDesign.logo
                ? surveyDesign.logo
                : require('@/assets/images/rush-logo.png')
            "
            fluid
            alt="Survey Logo"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="10" id="survey-title">
          {{ surveyDetails.title }}
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="10" id="message">
          We are sorry, the survey is currently over.
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NotAvailable",
  props: ["uuid"],
  computed: {
    ...mapGetters("survey", ["surveyDetails", "surveyDesign"]),
  },
};
</script>

<style>
</style>